// A form's refusal, said where the person looks (2026-10-12). A validation failure names its fields (dotted request
// paths such as `name` or `lines.0.quantity`): each message goes beside its input, through the form's own key for it.
// Any field the form has no input for, and every other refusal, becomes the form-level `form` notice, in the
// catalogue's words for the server's code (the action's own line for a code with no copy).

import { useCallback } from 'react';

import { useProblem } from '../api/use-problem';

/** Server request path -> the form's key for that input (or a function for patterns like `prices.2.rate`). */
export type ServerFieldMap = Readonly<Record<string, string>> | ((field: string) => string | undefined);

export type ServerErrors = Record<string, string>;

export function useServerErrors(): (error: unknown, fallback: string, fieldMap?: ServerFieldMap) => ServerErrors {
  const problem = useProblem();
  return useCallback(
    (error, fallback, fieldMap = {}) => {
      const view = problem.view(error, { fallback });
      if (!view.isValidation || view.fields.length === 0) return { form: problem.text(error, { fallback }) };
      const out: ServerErrors = {};
      const unplaced: string[] = [];
      for (const entry of view.fields) {
        const key = typeof fieldMap === 'function' ? fieldMap(entry.field) : fieldMap[entry.field];
        if (key === undefined) unplaced.push(entry.message);
        else if (out[key] === undefined) out[key] = entry.message;
      }
      if (unplaced.length > 0) out.form = unplaced.join(' ');
      return out;
    },
    [problem],
  );
}
